import { h } from 'preact';
import LoadingDots from '../LoadingDots';

const ButtonWrapper = ({
  isLoading = false,
  disabled = false,
  type = 'button',
  children,
  className = '',
  onClick,
}) => (
  <button
    type={type}
    disabled={isLoading || disabled}
    className={className}
    onClick={onClick}
  >
    {isLoading ? <LoadingDots /> : children}
  </button>
);

export default ButtonWrapper;
